// src/routes/PublicRoutes.jsx
import React from 'react';

// Public Candidate imports (tanpa auth)
import PublicAddCandidate from 'views/Kontak/PublicAddCandidate';
import PublicTest from 'views/Kontak/PublicTest';
import PublicEmployeeDocs from 'views/Kontak/PublicEmployeeDocs';
import PublicEmployeeDocuments from 'views/Public/EmployeeDocuments';

// ==============================|| PUBLIC ROUTES ||============================== //

const PublicRoutes = [
  { path: '/public/test', element: <PublicTest /> },
  { path: '/public/candidate/add', element: <PublicAddCandidate /> },
  { path: '/public/candidate/continue/:id', element: <PublicAddCandidate /> },
  { path: '/public/employee/docs/:id', element: <PublicEmployeeDocs /> },
  { path: '/public/documents/:token', element: <PublicEmployeeDocuments /> }
];

export default PublicRoutes;
